export default __webpack_public_path__ + "c34b9afabbe7ddc072fd11ba9fc49d93.png";